import React from "react"

const cleanColor = (val) => (val ? String(val).trim() : "")

const shade = (hex, percent) => {
  const c = cleanColor(hex).replace("#", "")
  if (!/^[0-9a-fA-F]{6}$/.test(c)) return null
  const num = parseInt(c, 16)
  const amt = Math.round(2.55 * percent)
  const r = Math.min(255, Math.max(0, (num >> 16) + amt))
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amt))
  const b = Math.min(255, Math.max(0, (num & 0x0000ff) + amt))
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`
}

const StatusBadge = ({ label, background, color }) => {
  if (!label) return null

  const bg = cleanColor(background) || "#f3f4f6"
  const fg = cleanColor(color) || "#374151"
  const borderColor = shade(bg, -15) || "#e5e7eb"

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-lg text-xs font-medium border whitespace-nowrap"
      style={{
        backgroundColor: bg,
        color: fg,
        borderColor,
      }}
    >
      <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: fg }} />
      {label}
    </span>
  )
}

export default StatusBadge
